export function getL1GroupingData(account) {
  const operationalGroup = {
    id: 'OPERATIONAL',
    displayLabel: 'Business Payments',
    displayOrder: 6,
    svgIconId: 'IconBanking',
    routeTo: '/transactions',
  };
  switch (account.type) {
    case 'BANK':
    case 'CASH':
    case 'CREDIT':
      return {
        id: 'BANKING',
        displayLabel: 'Banking',
        displayOrder: 1,
        svgIconId: 'IconBanking',
        routeTo: '/transactions',
      };
    case 'INVESTMENT':
      return {
        id: 'INVESTMENT',
        displayLabel: 'Investments',
        displayOrder: 2,
        svgIconId: 'IconInvestment',
        routeTo: '/investing?selectedTab=portfolio',
        balanceType: 'today',
      };
    case 'REAL_ESTATE':
    case 'VEHICLE':
      return {
        id: 'ASSET',
        displayLabel: 'Assets',
        displayOrder: 3,
        svgIconId: 'IconLoan',
        routeTo: '/transactions',
      };
    case 'ASSET':
    case 'OTHER_ASSET':
      // TODO: Remove the UNKNOWN when we fix UNDEPOSITED_FUNDS on QCS
      if (account.subType === 'UNDEPOSITED_FUNDS' || account.subType === 'UNKNOWN') {
        return operationalGroup;
      }
      return {
        id: 'ASSET',
        displayLabel: 'Assets',
        displayOrder: 4,
        svgIconId: 'IconLoan',
        routeTo: '/transactions',
      };
    case 'LOAN':
    case 'OTHER_LIABILITY':
      return {
        id: 'LIABILITY',
        displayLabel: 'Liabilities',
        displayOrder: 5,
        svgIconId: 'IconLoan',
        routeTo: '/transactions',
      };
    case 'ACCOUNTS_RECEIVABLE':
    case 'ACCOUNTS_PAYABLE':
    case 'PAYMENT':
      return operationalGroup;
    case 'GOAL':
      return {
        id: 'GOALS',
        displayLabel: 'Savings Goals',
        displayOrder: 7,
        svgIconId: 'IconLoan',
        routeTo: '/goals',
      };
    default:
      // assert(false, `Unexpected account type => ${account.type}`);
      return {
        id: 'OTHER',
        displayLabel: 'Other',
        displayOrder: 8,
        svgIconId: 'IconBanking',
        routeTo: '/transactions',
      };
  }
}

export function hasL2Grouping(id, numberOfAccounts) {
  switch (id) {
    case 'ASSET':
    case 'BANKING':
    case 'INVESTMENT':
    case 'LIABILITY':
      return numberOfAccounts > 0;
    default:
      return false;
  }
}

export function getL2GroupingData(node, account) {
  if (account.isExcludedFromAccountBar) {
    return {
      id: 'HIDDEN',
      displayLabel: 'Hidden',
      displayOrder: 100,
      routeTo: node?.routeTo,
    };
  }

  switch (account.type) {
    case 'BANK':
    case 'CASH':
    case 'CREDIT':
      if (account.type === 'CASH' || account.subType === 'CHECKING' || account.subType === 'DIGITAL_CASH') {
        return {
          id: 'CASH_CHECKING',
          displayLabel: 'Cash & Checking',
          displayOrder: 1,
          routeTo: node?.routeTo,
        };
      }
      if (account.type === 'CREDIT') {
        return {
          id: 'CREDIT',
          displayLabel: 'Credit',
          displayOrder: 2,
          routeTo: node?.routeTo,
        };
      }
      if (account.subType === 'SAVINGS' || account.subType === 'CD' || account.subType === 'MONEY_MARKET') {
        return {
          id: 'SAVINGS',
          displayLabel: 'Savings',
          displayOrder: 3,
          routeTo: node?.routeTo,
        };
      }
      if (account.subtype === 'TRUST' || account.subtype === 'RENTS_HELD_IN_TRUST') {
        return {
          id: 'FIDUCIARY',
          displayLabel: 'Fiduciary',
          displayOrder: 4,
          routeTo: node?.routeTo,
        };
      }
      return {
        id: 'OTHER_BANKING',
        displayLabel: 'Other Banking',
        displayOrder: 5,
        routeTo: node?.routeTo,
      };
    case 'INVESTMENT':
      switch (account.subType) {
        case 'BROKERAGE':
        case 'UGMA_UTMA':
          return {
            id: 'BROKERAGE',
            displayLabel: 'Brokerage',
            displayOrder: 6,
            routeTo: node?.routeTo,
            balanceType: 'today',
          };
        case '401K':
        case '403B':
        case 'IRA':
        case 'KEOGH':
        case 'ROTH_401K':
        case 'ROTH_IRA':
        case 'SEP_IRA':
        case 'SIMPLE_IRA':
          return {
            id: 'RETIREMENT',
            displayLabel: 'Retirement',
            displayOrder: 7,
            routeTo: node?.routeTo,
            balanceType: 'today',
          };
        case '529':
          return {
            id: 'EDUCATION',
            displayLabel: 'Education',
            displayOrder: 8,
            routeTo: node?.routeTo,
            balanceType: 'today',
          };
        case 'OTHER_INVESTMENT':
        default:
          return {
            id: 'OTHER_INVESTMENT',
            displayLabel: 'Other Investments',
            displayOrder: 9,
            routeTo: node?.routeTo,
            balanceType: 'today',
          };
      }
    case 'REAL_ESTATE':
      return {
        id: 'REAL_ESTATE',
        displayLabel: 'Real Estate',
        displayOrder: 10,
        routeTo: node?.routeTo,
      };
    case 'VEHICLE':
      return {
        id: 'VEHICLE',
        displayLabel: 'Vehicle',
        displayOrder: 11,
        routeTo: node?.routeTo,
      };
    case 'OTHER_ASSET':
      return {
        id: 'OTHER_ASSET',
        displayLabel: 'Other Assets',
        displayOrder: 12,
        routeTo: node?.routeTo,
      };
    case 'LOAN':
    case 'OTHER_LIABILITY':
      switch (account.subType) {
        case 'CONSTRUCTION_LOAN':
        case 'HOME_EQUITY':
        case 'MORTGAGE':
          return {
            id: 'HOME',
            displayLabel: 'Home Loan',
            displayOrder: 13,
            routeTo: node?.routeTo,
          };
        case 'AUTO_LOAN':
          return {
            id: 'AUTO_LOAN',
            displayLabel: 'Vehicle Loan',
            displayOrder: 14,
            routeTo: node?.routeTo,
          };
        case 'CONSUMER_LOAN':
        case 'MILITARY_LOAN':
        case 'STUDENT_LOAN':
          return {
            id: 'PERSONAL_LOAN',
            displayLabel: 'Personal Loan',
            displayOrder: 15,
            routeTo: node?.routeTo,
          };
        case 'TRUST_LIABILITY':
        case 'RENTS_HELD_IN_TRUST_LIABILITY':
          return {
            id: 'FIDUCIARY_LIABILITY',
            displayLabel: 'Fiduciary Liabilities',
            displayOrder: 16,
            routeTo: node?.routeTo,
          };
        default:
          return {
            id: 'OTHER_LIABILITY',
            displayLabel: 'Other Liabilities',
            displayOrder: 17,
            routeTo: node?.routeTo,
          };
      }
    default:
      return {
        id: 'OTHER',
        displayLabel: 'Other',
        displayOrder: 18,
        routeTo: node?.routeTo,
      };
  }
}
